<template>
  <div class="content">
    <div class="img_box">
      <div class="img_center">
        <div class="img_text">
          <div class="img_title">产业园区</div>
          <div class="img_content">
            思百达产业园区解决方案针对产业园区运营效率低、招商难度大、产业整合差、服务能力弱等问题提供信息化、数字化、智慧化的综合解决思路、产品及服务，通过思百达产业园区解决方案，园区运营管理方将提高效率、降低成本；园区企业能精准营销、提高营收；园区人员将安心工作，享受服务。
          </div>
        </div>
      </div>
    </div>

    <div class="contentCenter">
      <div class="designIdeas">
        <div class="designIdeasLeft">
          <div class="designIdeasTitle">
            <div>Applied Technologies</div>
            <div>技术基础</div>
          </div>
        </div>
        <div class="designIdeasRight">
          <div class="zmd">
            <el-carousel indicator-position="outside" arrow="never">
              <el-carousel-item
                v-for="(item, index) in ideasArr"
                v-lazy-container="{ selector: 'img' }"
                :key="index"
                :label="item.label"
              >
                <h3 class="ideas_btn">
                  <img :data-src="item.bacimg" alt="" />
                </h3>
                <div class="designIdeasRightText">
                  {{ item.text }}
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="designIdeas">
        <div class="successfulLeft">
          <ul class="successfulLeft_tree">
            <li>
              <span>1</span>
              <div>
                <div class="tree_desc_title">统一门户</div>
                <div class="tree_desc">园区统一中心门户</div>
              </div>
            </li>
            <li>
              <span>2</span>
              <div>
                <div class="tree_desc_title">三大平台</div>
                <div class="tree_desc">
                  园区综合管理平台<br />园区公共服务平台<br />园区营商助企平台
                </div>
              </div>
            </li>
            <li>
              <span>3</span>
              <div>
                <div class="tree_desc_title">一个中心</div>
                <div class="tree_desc">智慧运营中心（IOC）</div>
              </div>
            </li>
            <li>
              <span>4</span>
              <div>
                <div class="tree_desc_title">一颗大脑</div>
                <div class="tree_desc">智慧园区“数字大脑”</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="successfulRight">
          <div class="successTitle">
            <div>Application Objectives</div>
            <div>建设目标</div>
          </div>
        </div>
      </div>
      <div class="designIdeas">
        <div class="architectureLeft">
          <div class="designIdeasTitle">
            <div>System Architecture</div>
            <div>架构设计</div>
          </div>
        </div>

        <div class="architectureRight"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "governmentEnterprisePark",
  data() {
    return {
      ideasArr: [
        {
          label: "物联网",
          text: "传感设备、边缘计算、NB-IoT、RS485、MQTT…..",
          bacimg: require("../assets/物联网.jpg"),
        },
        {
          label: "大数据",
          text: "数据清洗、数据融合、数据挖掘、决策支持、算法抽象…..",
          bacimg: require("../assets/大数据.jpg"),
        },
        {
          label: "人工智能",
          text: "感知智能、认识智能、机器学习、深度学习、知识图谱…..",
          bacimg: require("../assets/人工智能.jpg"),
        },
        {
          label: "数字孪生",
          text: "3D建模、场景渲染、BIM、GIS、IOC、空间可视化…..",
          bacimg: require("../assets/数字孪生.jpg"),
        },
      ],
    };
  },
  methods: {},
};
</script>

<style scoped>
.title {
  font-size: 40px;
  color: #333;
}
.title > span:nth-of-type(2) {
  color: #0171bb;
}
.img_box {
  width: 100%;
  height: 400px;
  background-image: url(../assets/productPark.jpg);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #464646;
}
.img_center {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-weight: 400;
  color: #ffffff;
}
.img_title {
  width: 100%;
  margin-top: 102px;
  font-size: 60px;
}
.img_content {
  width: 75%;
  margin: 0 auto;
  font-size: 18px;
  line-height: 24px;
  margin-top: 26px;
  text-align: left;
}
/* 修改走马灯css开始 */

.el-carousel__item h3 {
  margin: 0;
  height: 100%;
}
.el-carousel >>> .el-carousel__indicator--horizontal {
  padding: 0;
}
.el-carousel >>> .el-carousel__indicators--outside {
  margin-top: 13px;
}

.el-carousel >>> .el-carousel__indicators--outside li {
  opacity: 1;
}
.el-carousel >>> .el-carousel__indicators--outside li button {
  position: relative;
  color: #404040;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  padding: 0;
  height: 10px;
  background-color: #0171bb;
}
.el-carousel >>> .el-carousel__indicator.is-active button {
  opacity: 1;
}
.el-carousel >>> .el-carousel__indicators--outside li:nth-of-type(1) button {
  border-radius: 10px 0 0 10px;
}
.el-carousel
  >>> .el-carousel__indicators--outside
  li:nth-last-of-type(1)
  button {
  border-radius: 0 10px 10px 0;
}
.el-carousel >>> .el-carousel__indicator.is-active button span {
  color: #0171bb;
}
.el-carousel >>> .el-carousel__indicators--outside li button span {
  color: #404040;
  position: absolute;
  top: 15px;
  left: 40px;
}

.el-carousel {
  overflow: visible;
}
.el-carousel >>> .el-carousel__container {
  overflow: hidden;
}
.el-carousel__button {
  background-color: transparent;
  border: 1px solid;
}
.el-carousel >>> .el-carousel__indicators--outside >>> .el-carousel__button {
  background-color: #000;
  opacity: 1;
}
.el-carousel >>> .el-carousel__indicator--horizontal {
  padding-left: 0;
  padding-right: 0;
  width: 100%;
}
.el-carousel >>> .el-carousel__indicators--outside {
  display: flex;
}
/* 修改走马灯css结束 */
.content {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 90px;
  margin: 0;
  padding: 0;
  position: relative;
}
.contentCenter {
  padding-bottom: 80px;
}
@media (min-width: 768px) {
  .contentCenter {
    width: 800px;
  }
}
@media (min-width: 1000px) {
  .contentCenter {
    width: 970px;
  }
}
@media (min-width: 1280px) {
  .contentCenter {
    width: 1200px;
  }
}
.designIdeas {
  display: flex;
  margin-top: 150px;
}
.designIdeasLeft,
.designIdeasRight {
  display: flex;
  width: 45%;
}
.architectureLeft,
.successfulRight {
  display: flex;
  width: 30%;
  align-items: center;
}
.architectureRight,
.successfulLeft {
  display: flex;
  width: 60%;
}
.designIdeasLeft {
  flex-direction: column;
  margin-right: 50px;
}
.designIdeasTitle {
  height: 50%;
  border-left: 6px solid #0171bb;
  display: flex;
  flex-direction: column;
  padding-left: 60px;
  justify-content: center;
}
.successTitle {
  height: 50%;
  border-bottom: 6px solid #f9ae3b;
  display: flex;
  flex-direction: column;
  padding-bottom: 60px;
  justify-content: center;
}
.designIdeasTitle > div:nth-child(1),
.successTitle > div:nth-child(1) {
  font-size: 60px;
  color: #404040;
}
.designIdeasTitle > div:nth-child(2),
.successTitle > div:nth-child(2) {
  font-size: 40px;
  color: #404040;
}
.designIdeasText {
  color: #bdbdbd;
  padding-left: 66px;
  font-size: 17px;
  width: 400px;
}
.designIdeasRight,
.architectureRight,
.successfulLeft {
  height: 100%;
  position: relative;
}
.designIdeasRightText {
  position: absolute;
  bottom: 0;
  height: 40px;
  line-height: 40px !important;
  width: 100%;
  color: #fff;
  line-height: 60px;
  background-color: #1f1f1f;
  text-align: center;
  z-index: 99;
  opacity: 0.8;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.zmd {
  width: 100%;
  height: 100%;
}
.el-carousel__container {
  height: 540px;
}
.successfulLeft_tree {
  width: 360px;
  display: block;
  height: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
}
.successfulLeft_tree li {
  display: block;
  height: 25%;
  width: 100%;
  margin-bottom: 28px;
}
.successfulLeft_tree li span {
  display: inline-block;
  height: 100%;
  width: 112.5px;
  background: #f9ae3b;
  border-radius: 50%;
  margin-right: 42px;
  line-height: 112.5px;
  text-align: center;
  color: white;
  font-size: 60px;
}
.successfulLeft_tree > li > div {
  float: right;
  height: 100%;
  width: 200px;
}
.tree_desc_title,
.tree_desc {
  display: inline-block;
  height: 50%;
  width: 285px;
  font-size: 18px;
  color: #8d8d8d;
}
.tree_desc_title {
  font-size: 30px;
  line-height: 56px;
  color: #404040;
}
.home_title {
  position: absolute;
  top: -387px;
  width: 1011px;
  height: 78px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
}
.home_title1 {
  font-size: 50px;
  font-weight: bold;
  line-height: 109px;
  text-align: center;
}
.architectureRight {
  width: 700px;
  height: 380px;
  margin-left: 150px;
  background: url(../assets/product1.png) no-repeat;
  background-size: cover;
}
.successfulLeft1 {
  width: 700px;
  border-radius: 4px;
  margin-right: 150px;
  background: url(../assets/product3.png) no-repeat 100%;
  position: relative;
  background-size: cover;
}
.successfulLeft2 {
  width: 100%;
  height: 100%;
  background: #0171bbaf;
  padding: 80px 41px 89px 64px;
  box-sizing: border-box;
  opacity: 0;
  transition: all 0.6s;
}
.successfulLeft2:hover {
  opacity: 1;
}
.successfulLeft2 > div:nth-of-type(1) {
  height: 40px;
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
}
.successfulLeft2 > div:nth-of-type(2) {
  margin-top: 31px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
}
.ideas_btn > img {
  width: 100%;
  height: 100%;
}
@media (max-width: 1200px) {
  .contentCenter {
    width: 100%;
  }
  .designIdeasText {
    margin-top: 10px;
    width: auto;
  }
  .designIdeasTitle {
    padding-left: 50px;
  }
  .successfulLeft2 > div:nth-of-type(2) {
    font-size: 13px;
  }
  .successfulLeft2 > div:nth-of-type(1) {
    font-size: 20px;
  }
  .home_title {
    width: 85%;
    font-size: 13px;
  }
  .designIdeasRightText {
    font-size: small;
  }
}

@media (max-width: 425px) {
  .contentCenter {
    padding-bottom: 30px;
  }
  .successfulLeft_tree li span {
    margin-right: 0;
    margin-left: 60px;
  }
  .designIdeas {
    margin-top: 60px;
    flex-direction: column-reverse;
  }
  .contentCenter > div:nth-of-type(1) {
    flex-direction: column;
  }
  .designIdeasTitle > div:nth-child(1),
  .successTitle > div:nth-child(1) {
    font-size: 30px;
  }
  .designIdeasLeft,
  .designIdeasRight {
    width: 100%;
  }
  .designIdeasTitle > div:nth-child(2),
  .successTitle > div:nth-child(2) {
    font-size: 23px;
  }
  .successTitle {
    padding-bottom: 20px;
    margin-bottom: 20px;
    padding-left: 10px;
  }
  .designIdeasRight {
    margin-bottom: 20px;
  }
  .tree_desc {
    font-size: 12px;
    color: #333;
  }
  .architectureRight,
  .successfulLeft {
    width: auto;
  }
  .contentCenter > div:nth-of-type(3) {
    flex-direction: column;
  }
  .architectureRight {
    margin: 0;
    margin-top: 20px;
    background-size: 100%;
  }
  .architectureRight {
    height: 230px;
  }
  .successfulLeft1 {
    width: 100%;
  }
  .successfulLeft2 {
    padding: 20px;
  }
  .designIdeasTitle {
    margin-bottom: 20px;
  }
  .home_content {
    font-size: 13px;
    line-height: 22px;
    /* text-indent: 2em; */
  }
  .home_title1 {
    font-size: 40px;
  }
  .el-carousel__item {
    background-color: transparent !important;
  }
  .successfulLeft2 > div:nth-of-type(1) {
    font-size: 19px;
  }
  .img_center {
    width: 100%;
  }
  .img_title {
    font-weight: bold;
    font-size: 20px;
    margin-top: 40px;
  }
  .img_content {
    font-size: 12px;
    line-height: 18px;
    /* text-indent: 2em; */
    width: 90%;
    margin-top: 20px;
    text-align: left;
  }
  .img_box {
    height: 270px;
  }
  .designIdeasTitle > div:nth-child(1),
  .successTitle > div:nth-child(1) {
    font-size: 16px;
    color: #999;
  }
  .ideas_btn > img {
    object-fit: contain;
  }

  .designIdeas {
    margin-top: 50px;
  }
  .designIdeasTitle {
    padding-left: 30px;
  }
  .designIdeasText {
    font-size: 12px;
  }
  .designIdeasLeft {
    margin-top: 20px;
  }
  .successfulLeft_tree li span {
    width: 80px;
    height: 80px;
    line-height: 80px;
    font-size: 30px;
  }
  .tree_desc_title {
    font-size: 20px;
    line-height: 37px;
  }
  .designIdeasText {
    margin-top: 25px;
    /* text-indent: 2em; */
    color: #333;
  }
  .successfulLeft2 > div:nth-of-type(2) {
    margin-top: 10px;
    font-size: 12px;
    /* text-indent: 2em; */
    line-height: 20px;
  }
  /* 425px下设备修改走马灯css开始 */
  .el-carousel >>> .el-carousel__indicators--outside {
    margin-top: 15px;
    margin-left: 5px;
    margin-right: 5px;
  }
  .el-carousel >>> .el-carousel__indicators--outside li button span {
    left: 28px;
    font-size: 12px;
  }
  .el-carousel__item h3 {
    line-height: 0px;
    height: auto;
  }
  .el-carousel__item {
    height: auto;
  }
  .el-carousel >>> .el-carousel__container {
    height: 285px;
  }
  /* 425px下设备修改走马灯css结束 */
  .designIdeasTitle,
  .successTitle {
    border: none;
    flex-direction: column-reverse;
    margin: 0 auto;
    padding: 0;
    text-align: center;
    margin-bottom: 50px;
  }
  .architectureLeft,
  .successfulRight {
    width: 100%;
    text-align: center;
  }
  .successfulLeft_tree li:nth-last-of-type(1) {
    margin-bottom: 0;
  }
  .successfulLeft_tree > li > div {
    width: 190px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/productPark.vue